export const moduleIndex = [
  { id: 'human-capability-edition', name: 'Human Capability Edition', summary: 'Assess capabilities and support their development' },
  { id: 'talent', name: 'Noetivra Talent', summary: 'Evidence that a candidate can do the job' },
  { id: 'clinical', name: 'Noetivra Clinical', summary: 'Clinical observations with relevant knowledge' },
  { id: 'research', name: 'Noetivra Research', summary: 'Help researchers connect ideas' },
  { id: 'collaboration', name: 'Noetivra Collaboration', summary: 'Work across teams and organizations' },
]

export const capabilityWorkflow = [
  { step: 'Identify', text: 'Identify a capability gap.' },
  { step: 'Explain', text: 'Explain the finding.' },
  { step: 'Recommend', text: 'Recommend an appropriate activity.' },
  { step: 'Reassess', text: 'Reassess whether it helped.' },
]

export const talentFeatures = [
  { title: 'Define role requirements', text: 'Connect responsibilities to specific skills and capabilities.' },
  { title: 'Prepare structured interviews', text: 'Select approved questions, work exercises, and scoring rubrics.' },
  { title: 'Organize candidate evidence', text: 'Connect answers, submitted work, and verified experience to each requirement.' },
  { title: 'Identify gaps', text: 'Flag vague claims and suggest questions that clarify the candidate’s contribution.' },
  { title: 'Review consistently', text: 'Record ratings alongside the responses or work supporting them.' },
  { title: 'Compare candidates', text: 'Examine demonstrated strengths, unanswered questions, and reviewer disagreements.' },
]

export const talentExample = [
  {
    requirement: 'Planning',
    demonstrated: 'Created a workable schedule and identified dependencies.',
    unclear: 'How they would respond to a missed milestone.',
  },
  {
    requirement: 'Budget management',
    demonstrated: 'Described tracking project expenses.',
    unclear: 'Whether they owned the budget or assisted another manager.',
  },
  {
    requirement: 'Handling setbacks',
    demonstrated: 'Explained a recovery plan and its tradeoffs.',
    unclear: 'Which decisions they personally made.',
  },
]

export const poweredBy = [
  { name: 'Semantic Knowledge Platform', role: 'Supplies the knowledge', link: '/semantic-knowledge' },
  { name: 'Human Capability Platform', role: 'Supplies capability assessment and development frameworks', link: '/human-capability' },
  { name: 'Noetivra', role: 'Brings these resources into professional practice', link: null },
]
